import { render } from "./DImg.vue?vue&type=template&id=ad963bb0"
import script from "./DImg.vue?vue&type=script&lang=js"
export * from "./DImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__